import * as React from 'react';
import Axios, { AxiosResponse } from 'axios';
import { withTranslation } from 'react-i18next';
import { IMedia } from '../interfaces';
import config from '../config';
import i18n from '../config/i18next';
import Banner from '../components/parts/Banner';
import Helmet from 'react-helmet';

interface IState {
    isLoading: boolean,
    media: IMedia
}

class Reklama extends React.Component<any, IState>{
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.state = {
            isLoading: true,
            media: null
        };

    }

    componentWillReceiveProps(nextProps: any) {
        this.componentDidMount();
    }

    async componentDidMount() {
        try {
            let response: AxiosResponse = await Axios.get(`${config.site}/${i18n.language}/api/stat/reklama`);

            this.setState({
                isLoading: false,
                media: response.data
            });
        } catch {

        }
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    render() {
        const { t } = this.props;

        return (
            <div className="i-body">
                <Helmet>
                    <title>{t("Реклама на сайте") + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>
                </Helmet>
                <div className="container login-page v-index">
                    <div className="wrap games watch">
                        <div className="row">
                            <div className="col-md-9 col-xs-12">

                                <div className="info pb-20">
                                    <h3>{t("Реклама на сайте")}</h3>

                                    {this.state.isLoading && <div className="carousel-placeholder" />}

                                    {!this.state.isLoading && (<div className="mt-15" dangerouslySetInnerHTML={{
                                        __html: this.state.media.info
                                    }}>

                                    </div>)}

                                </div>
                            </div>
                            <div className="col-md-3 col-xs-12">
                                <Banner className="banner300" place={37} />

                            </div>
                        </div>
                    </div>
                    <Banner className="banner235" place={38} />

                </div>
            </div>
        );
    }
}

export default withTranslation()(Reklama);